import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <div className="footer-container">
            <a href="https://www.github.com/linkinsunil" className="footer-link"
            target="_blank"
            rel="noreferrer"
            >
                View on Github            
            </a>
        </div>
    )
}

export default Footer;